<div class="page-head-section">
  <p>{{Category}}</p>
</div>

<div class="award-content">
    <p class="subhead">List of {{Category}} Winners:</p>
  <div class="ui-g">
   

    <div *ngFor="let data of awards" class="ui-g-3 ui-lg-3 ui-md-6 ui-sm-12">
      <div class="award-card">
        <div class="award-card-image">
          <img class="image-responsive" [src]="global.basePathImage+data.photo" alt="" />
        </div>
        <div class="award-card-content">
          <h1>{{ data?.name }}</h1>
          <p>{{ data?.year }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
